<ul class="list-unstyled">
	<li class="dropdown pc-h-item" ngbDropdown>
		<a class="pc-head-link dropdown-toggle arrow-none me-0 bg-gray-200" data-bs-toggle="dropdown" ngbDropdownToggle>
			<i antIcon type="bell" theme="outline"></i>
			@if (unreadCount > 0) {
				<span class="badge bg-primary pc-h-badge">{{ unreadCount }}</span>
			}
		</a>
		<div class="dropdown-menu dropdown-notification dropdown-menu-end pc-h-dropdown" ngbDropdownMenu>
			<div class="dropdown-header d-flex align-items-center justify-content-between">
				<h5 class="m-0">Notificaciones</h5>
				@if (unreadCount > 0) {
					<a class="bg-transparent cursor-pointer" (click)="markAllAsRead()" title="Marcar todas como leídas">
						<i class="text-success d-flex f-20" antIcon theme="outline" type="check-circle"></i>
					</a>
				}
			</div>
			<div class="dropdown-divider"></div>
			<ng-scrollbar style="min-height: 300px; max-height: 400px" visibility="hover">
				<div class="dropdown-header px-0 text-wrap header-notification-scroll">
					@if (isLoadingNotifications) {
						<div class="text-center py-4">
							<div class="spinner-border text-primary" role="status">
								<span class="visually-hidden">Cargando...</span>
							</div>
						</div>
					} @else if (recentNotifications.length === 0) {
						<div class="text-center py-4">
							<i
								class="d-flex justify-content-center mb-2"
								antIcon
								theme="outline"
								type="bell"
								style="font-size: 48px; color: #ccc"
							></i>
							<p class="text-muted">No tienes notificaciones recientes</p>
						</div>
					} @else {
						<div class="list-group list-group-flush w-100">
							@for (notification of recentNotifications; track notification.id) {
								<a
									class="list-group-item list-group-item-action"
									[class.bg-light]="!notification.isRead"
									style="cursor: pointer"
								>
									<div class="d-flex">
										<div class="flex-shrink-0">
											<div class="user-avatar {{ getNotificationColorClass(notification.notification.type) }}">
												<i
													class="d-flex"
													antIcon
													theme="outline"
													type="{{ getNotificationIcon(notification.notification.type) }}"
												></i>
											</div>
										</div>
										<div class="flex-grow-1 ms-3">
											<span class="float-end text-muted">{{ getFormattedTime(notification.createdAt) }}</span>
											<p class="text-body mb-0 fw-semibold">
												{{ notification.notification.title }}
											</p>
											<p class="text-muted small mb-1">
												{{ notification.notification.description }}
											</p>
											<span class="text-muted small">{{ getRelativeTime(notification.createdAt) }}</span>
											@if (!notification.isRead) {
												<span class="badge bg-primary ms-2">Nueva</span>
											}
										</div>
									</div>
								</a>
							}
						</div>
					}
				</div>
			</ng-scrollbar>
			<div class="dropdown-divider"></div>
			<div class="text-center py-2">
				<a class="link-primary cursor-pointer" [routerLink]="['/notifications/list']">Ver todas</a>
			</div>
		</div>
	</li>
	<li class="dropdown pc-h-item header-user-profile" ngbDropdown *ngIf="getProfile">
		<a class="pc-head-link dropdown-toggle arrow-none me-0" ngbDropdownToggle>
			<img src="assets/images/user/avatar-2.jpg" alt="user-image" class="user-avatar me-2" />
			<span class="f-w-600">{{
				getProfile.roleId === 5 ? getProfile.legalName : getProfile.firstName + ' ' + getProfile.firstLastName
			}}</span>
		</a>
		<div class="dropdown-menu dropdown-user-profile dropdown-menu-end pc-h-dropdown" ngbDropdownMenu>
			<div class="dropdown-header">
				<div class="d-flex mb-1">
					<div class="flex-shrink-0">
						<img src="assets/images/user/avatar-2.jpg" alt="user-image" class="user-avatar wid-35" />
					</div>
					<div class="flex-grow-1 ms-3 text-start">
						<h6 class="mb-0">
							{{
								getProfile.roleId === 5 ? getProfile.legalName : getProfile.firstName + ' ' + getProfile.firstLastName
							}}
						</h6>
						<span class="text-ellipsis">{{ getProfile.email }}</span>
					</div>
					<div class="cursor-pointer">
						<a (click)="onLogout()" class="bg-transparent"
							><i class="d-flex f-20" antIcon theme="outline" type="logout"></i
						></a>
					</div>
				</div>
			</div>
			<ul ngbNav #nav="ngbNav" class="nav drp-tabs nav-fill nav-tabs">
				<li ngbNavItem="1">
					<a ngbNavLink>
						<i antIcon theme="outline" type="user" class="me-2"></i>
						Profile
					</a>
					<ng-template ngbNavContent>
						@for (task of profile; track task) {
							<div>
								<a class="dropdown-item cursor-pointer" [routerLink]="task.route">
									<i class="text-muted" antIcon theme="outline" type="{{ task.icon }}"></i>
									<span>{{ task.title }}</span>
								</a>
							</div>
						}
						<div class="cursor-pointer">
							<a class="dropdown-item" (click)="onLogout()">
								<i class="text-muted" antIcon theme="outline" type="logout"></i>
								<span>Cerrar sesión</span>
							</a>
						</div>
					</ng-template>
				</li>
				<li ngbNavItem="2">
					<a ngbNavLink>
						<i class="me-2" antIcon theme="outline" type="setting"></i>
						Setting
					</a>
					<ng-template ngbNavContent>
						@for (task of setting; track task) {
							<div>
								<a class="dropdown-item cursor-pointer" [routerLink]="task.route">
									<i class="text-muted" antIcon theme="outline" type="{{ task.icon }}"></i>
									<span>{{ task.title }}</span>
								</a>
							</div>
						}
					</ng-template>
				</li>
			</ul>
			<div [ngbNavOutlet]="nav"></div>
		</div>
	</li>
</ul>
